export const BoxShadow = {
  medium: '0px 4px 12px 0px #BABCBF40',
  large: '0px 12px 24px 0px #2021251F',
};
